import { Selector } from '../../lib/generated/zeus';

const rosterShiftSelector = Selector('RosterShift')({
  id: true,
  startTime: true,
  endTime: true,
  isRecurring: true,
  recordStatus: true,
  recurrencePattern: true,
  isDerived: true,
  originalShiftId: true,
  teamRoleName: true,
  team: {
    id: true,
    name: true,
  },
});

export const userShiftClashReportSelector = Selector('UserShiftClashReport')({
  userId: true,
  clashedShiftGroups: {
    shifts: rosterShiftSelector,
  },
});
